"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateListItem = void 0;
var react_1 = __importStar(require("react"));
var luxon_1 = require("luxon");
var classnames_1 = __importDefault(require("classnames"));
var Types_1 = require("@CommonFrontendBackend/Templates/Types");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var GetFullName_1 = require("@CommonFrontendBackend/Utils/GetFullName");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var CrmPill_1 = require("./CrmPill");
var useTemplatesDashboardTelemetry_1 = require("Dashboard/TemplateManagementDashboard/useTemplatesDashboardTelemetry");
var GetProjectNameWithDefault_1 = require("@CommonFrontendBackend/Utils/GetProjectNameWithDefault");
var TemplateAlgorithmButton_1 = require("./TemplateAlgorithmButton");
var c = (0, BemBuilder_1.default)("template-list-item");
var TemplateListItem = function (props) {
    var _a;
    var _b;
    var template = props.template, options = props.options, button = props.button, onClick = props.onClick, selectStyle = props.selectStyle, selected = props.selected, onDragStart = props.onDragStart, onDragEnd = props.onDragEnd, showEngagementButton = props.showEngagementButton, openAssignAutomationModal = props.openAssignAutomationModal;
    var _c = __read((0, react_1.useState)(false), 2), isCheckboxSelected = _c[0], setCheckboxSelected = _c[1];
    var useCheckbox = selectStyle == "checkbox";
    var useCornerTicks = selectStyle == "cornertick";
    var toggleSelected = function () {
        setCheckboxSelected(!isCheckboxSelected);
    };
    var onInsideClick = function (event, callback) {
        event.stopPropagation();
        if (callback) {
            return callback();
        }
    };
    var getSize = function () {
        var maxLength = options.reduce(function (acc, option) {
            return acc > option.displaytext.length ? acc : option.displaytext.length;
        }, 0);
        return maxLength > 15 ? "large" : "medium";
    };
    var potentiallyRenderAutomationsButton = function (automationState, openAssignAutomationModal) {
        if (automationState &&
            openAssignAutomationModal &&
            [Types_1.AutomationState.Assigned, Types_1.AutomationState.Assignable].includes(automationState)) {
            return (react_1.default.createElement("div", { className: c("automation-icon") },
                react_1.default.createElement(kaleidoscope_1.IconButton, { className: c("automation-icon"), icon: automationState === Types_1.AutomationState.Assigned && openAssignAutomationModal ? (react_1.default.createElement(icons_1.AutomationColor, null)) : (react_1.default.createElement(icons_1.Automation, null)), onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    e.stopPropagation();
                                    return [4, openAssignAutomationModal()];
                                case 1:
                                    _a.sent();
                                    return [2];
                            }
                        });
                    }); }, buttonState: kaleidoscope_1.ButtonState.Idle, size: kaleidoscope_1.ButtonSize.Small, tooltip: {
                        content: automationState === Types_1.AutomationState.Assigned ? "Edit Automation" : "Assign Automation",
                    } })));
        }
        return null;
    };
    return (react_1.default.createElement("div", { draggable: !!onDragStart, onDragStart: onDragStart, onDragEnd: onDragEnd },
        react_1.default.createElement(kaleidoscope_1.ButtonCard, { onClick: onClick, className: (0, classnames_1.default)(c(), (_a = {}, _a[c("", "selected")] = selected, _a)) },
            react_1.default.createElement("div", { className: c("wrapper") },
                react_1.default.createElement("div", { className: (0, classnames_1.default)(c("icon-placeholder"), isCheckboxSelected && c("checkbox-visible")) },
                    react_1.default.createElement(icons_1.Template, { className: (0, classnames_1.default)(c("template-icon"), useCheckbox && "hide-on-hover"), size: icons_1.IconSize.Medium }),
                    useCheckbox && (react_1.default.createElement("div", { className: "show-hide" },
                        react_1.default.createElement(kaleidoscope_1.Checkbox, { item: { id: template._id, value: template._id, label: undefined }, isSelected: isCheckboxSelected, onChange: toggleSelected, size: kaleidoscope_1.CheckboxSize.Medium, labelHidden: true })))),
                react_1.default.createElement("div", { className: c("details") },
                    react_1.default.createElement("div", { className: c("details-left") },
                        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "l", className: c("details-left__template-name") }, (0, GetProjectNameWithDefault_1.getProjectNameWithDefault)(template.name)),
                        react_1.default.createElement("div", { className: c("details-left__last-edited") },
                            react_1.default.createElement(kaleidoscope_1.Text, { className: "show-hide", size: "xs" }, "Last edited: ".concat(luxon_1.DateTime.fromISO(template.lastEditedAt).toLocaleString({
                                dateStyle: "medium",
                                timeStyle: "short",
                                hourCycle: "h12",
                            }), ". Created by: ").concat((0, GetFullName_1.buildName)(template.user.firstName, template.user.lastName))))),
                    react_1.default.createElement("div", { className: c("details-right") },
                        react_1.default.createElement(CrmPill_1.CrmPill, { crmInfo: props.template.crmInfo }),
                        potentiallyRenderAutomationsButton((_b = props.template.crmInfo.automations) === null || _b === void 0 ? void 0 : _b.automationState, props.openAssignAutomationModal),
                        showEngagementButton && (react_1.default.createElement(TemplateAlgorithmButton_1.TemplateAlgorithmButton, { templateId: template._id, templateName: template.name })),
                        options && options.length > 0 && (react_1.default.createElement(kaleidoscope_1.OptionMenu, { className: c("option-menu"), size: getSize(), button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, null), onClick: onInsideClick, size: kaleidoscope_1.ButtonSize.Small }) }, options.map(function (option, index) {
                            return (react_1.default.createElement(react_1.default.Fragment, null,
                                option.destructive && react_1.default.createElement(kaleidoscope_1.OptionMenuSeparator, { key: "separator" }),
                                react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { key: index, onClick: function (e) {
                                        return onInsideClick(e, function () {
                                            return option.callback(useTemplatesDashboardTelemetry_1.TemplateManagementDashboardSources.TemplatesListOptionsMenu);
                                        });
                                    }, icon: option.icon, disabled: !option.enabled, destructive: option.destructive && option.enabled }, option.displaytext)));
                        }))),
                        button && (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: function (e) { return onInsideClick(e, button.callback); }, className: "template-button" }, button.displaytext)))),
                useCornerTicks && selected && react_1.default.createElement(icons_1.Tick, { className: c("cornerTick") })))));
};
exports.TemplateListItem = TemplateListItem;
TemplateListItem.defaultProps = {
    selected: false,
};
